import React from 'react';
import { motion } from 'framer-motion';
export function EarlyAccessSection() {
  return <section className="py-32 bg-ascension-black relative overflow-hidden" data-id="element-69">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-ascension-green/10 blur-[100px] pointer-events-none rounded-t-full" data-id="element-70" />

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-ascension-dark rounded-3xl p-10 md:p-16 border border-white/10 text-center shadow-2xl" data-id="element-72">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight" data-id="element-73">
            Start Your Ascension.
          </h2>
          <p className="text-ascension-gray text-lg mb-10 max-w-xl mx-auto" data-id="element-74">
            Join the early access list and begin building unbreakable discipline
            today. Spots are limited.
          </p>

          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" onSubmit={e => e.preventDefault()} data-id="element-75">
            <input type="email" placeholder="Enter your email" className="flex-1 bg-ascension-black border border-white/10 rounded-xl px-5 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-ascension-green focus:ring-1 focus:ring-ascension-green transition-all" required data-id="element-76" />
            <button type="submit" className="bg-ascension-green hover:bg-[#3bb34c] text-black px-8 py-4 rounded-xl font-semibold transition-all duration-200 shadow-[0_0_20px_rgba(68,198,87,0.2)] hover:shadow-[0_0_30px_rgba(68,198,87,0.4)] whitespace-nowrap" data-id="element-77">
              Get Early Access
            </button>
          </form>

          <p className="text-xs text-ascension-gray/50 mt-6" data-id="element-78">
            No spam. Unsubscribe at any time.
          </p>
        </motion.div>
      </div>
    </section>;
}